import {ContactSellerRequest} from './ContactSellerRequest.js'

export class ContactModelSellerRequest extends ContactSellerRequest {
  getType() {
    return this._type
  }

  getMakeId() {
    return this._makeId
  }

  getModelId() {
    return this._modelId
  }

  getUserId() {
    return this._userId
  }

  getCaptchaToken() {
    return this._captchaToken
  }

  toJSON() {
    return {
      captchaToken: this._captchaToken,
      vehicleInfo: {
        makeId: this._makeId,
        modelId: this._modelId
      },
      buyer: {
        id: this._userId,
        name: this._name,
        surname: this._surname,
        email: this._email,
        phoneNumber: this._phone,
        postalCode: this._postalCode
      },
      type: this._type
    }
  }
}
